import { AxiosInstance } from "axios";
import { Menu } from "../types/Menu";
import { Domaine } from "../types/Domaine";

export const MenuService = {
  getAllMenus: async (api: AxiosInstance): Promise<Menu[]> => {
    try {
      const response = await api.get('/menu-management/all');

      return response.data.map((menu: any) => ({
        id: menu.idMenu,
        label: menu.nomMenu,
        iconLabel: menu.iconLabel,
      }));

    } catch (error) {
      console.error('Erreur lors de la récupération des menus:', error);
      throw error;
    }
  },

  getAllMenuDetails: async (api: AxiosInstance): Promise<Domaine[]> => {
    try {
      const response = await api.get("/menu-management/details");
      const data = response.data as any[];

      return data.map((menu: any) => ({
        id: menu.idMenu,
        label: menu.nomMenu,
        iconName: menu.iconLabel,
        mIsActive: menu.isActive,
        icon: () => null,
        sousDomaines: menu.fenetres
          ? menu.fenetres.map((fen: any) => ({
              id: fen.idFenetre,
              label: fen.nomFenetre,
              tbl_name: fen.tblName,
              sIsActive: fen.isActive,
              sousSousDomaines: fen.sousFenetres
                ? fen.sousFenetres.map((sf: any) => ({
                    id: sf.idSousFenetre,
                    label: sf.nomSousFenetre,
                    sfIsActive: sf.isActive,
                    iconLabel: sf.tblName,
                  }))
                : [],
            }))
          : [],
      }));
    } catch (error) {
      console.error("Erreur lors du chargement des détails menus :", error);
      throw error;
    }
  },

    getAllMenuDetailsIsActive: async (api: AxiosInstance): Promise<Domaine[]> => {
    try {
      const response = await api.get("/menu-management/details-is-active");
      const data = response.data as any[];

      return data.map((menu: any) => ({
        id: menu.idMenu,
        label: menu.nomMenu,
        iconName: menu.iconLabel,
        mIsActive: menu.isActive,
        icon: () => null,
        sousDomaines: menu.fenetres
          ? menu.fenetres.map((fen: any) => ({
              id: fen.idFenetre,
              label: fen.nomFenetre,
              tbl_name: fen.tblName,
              sIsActive: fen.isActive,
              sousSousDomaines: fen.sousFenetres
                ? fen.sousFenetres.map((sf: any) => ({
                    id: sf.idSousFenetre,
                    label: sf.nomSousFenetre,
                    sfIsActive: sf.isActive,
                    iconLabel: sf.tblName,
                  }))
                : [],
            }))
          : [],
      }));
    } catch (error) {
      console.error("Erreur lors du chargement des détails menus :", error);
      throw error;
    }
  },

  insertMenu: async (api: AxiosInstance, menu: Menu): Promise<Menu> => {
    try {
      const response = await api.post('/menu-management/add-menu', {
        nomMenu: menu.label,
        iconLabel: menu.iconLabel,
      });

      return {
        id: response.data.idMenu,
        label: response.data.nomMenu,
        iconLabel: response.data.iconLabel,
      };

    } catch (error: any) {
      console.error("Erreur lors de l'ajout du menu :", error);

      if (error.response?.data?.error) {
        throw new Error(error.response.data.error);
      }

      throw error;
    }
  },

  enableMenu: async (api: AxiosInstance, idMenu: number): Promise<number> => {
  try {
    const response = await api.put(`/menu-management/enable/${idMenu}`);
    return response.data; 
  } catch (error: any) {
    console.error(`Erreur lors de l'activation du menu ${idMenu}:`, error);
    if (error.response?.data) {
      throw new Error(error.response.data);
    }
    throw error;
  }
},

  disableMenu: async (api: AxiosInstance, idMenu: number): Promise<number> => {
    try {
      const response = await api.put(`/menu-management/disable/${idMenu}`);
      return response.data; 
    } catch (error: any) {
      console.error(`Erreur lors de la désactivation du menu ${idMenu}:`, error);
      if (error.response?.data) {
        throw new Error(error.response.data);
      }
      throw error;
    }
  },
};
